import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';

export const savingsAccountNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> =
  new Map([
    [
      ButtonActionType.CLOSE_SAVINGS_ACCOUNT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.MATURITY_DECISION_WITHDRAW,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.MATURITY_DECISION_PARTIAL_REINVEST,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.OPEN_NEW_SAVINGS_ACCOUNT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
        [ActionButtonOutcomesType.PROCESSING]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_1]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.INITIATE_SAVINGS_INTERNAL_TRANSFER,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.WITHDRAW_FROM_SAVINGS_ACCOUNT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_1]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.MATURITY_DECISION_RENEW,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.CANCEL_PENDING_WITHDRAWAL,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.CHECK_PAYEE_FOR_NOMINATED_BANK_ACCOUNT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.UPDATE_NOMINATED_BANK_ACCOUNT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.INVITE_JOINT_ACCOUNT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.ACCEPT_JOINT_ACCOUNT_INVITATION,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_1]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.DECLINE_JOINT_ACCOUNT_INVITATION,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.PISP_CANCEL_RECURRING_PAYMENT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
  ]);
